export const normalizeRole = (role) => (role === 'viewer' ? 'boss' : role);

export const isBossLikeRole = (role) => normalizeRole(role) === 'boss';

export const canAccessBossModules = (role) => ['admin', 'boss'].includes(normalizeRole(role));

export const getRoleLabel = (role) => {
    const normalizedRole = normalizeRole(role);

    if (normalizedRole === 'admin') return 'Yönetici';
    if (normalizedRole === 'staff') return 'Personel';
    if (normalizedRole === 'shipment_staff') return 'Saha Personeli';
    if (normalizedRole === 'boss') return 'Patron';
    return normalizedRole;
};
